var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2C15 1.44772 14.5523 1 14 1C13.4477 1 13 1.44772 13 2V5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5V2Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23C15 22.4477 14.5523 22 14 22C13.4477 22 13 22.4477 13 23V26C13 26.5523 13.4477 27 14 27C14.5523 27 15 26.5523 15 26V23Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8923 20.866C24.3706 21.1422 24.9822 20.9783 25.2583 20.5C25.5345 20.0217 25.3706 19.4101 24.8923 19.134L22.2942 17.634C21.8159 17.3578 21.2043 17.5217 20.9282 18C20.652 18.4783 20.8159 19.0899 21.2942 19.366L23.8923 20.866Z",
    fill: "#023F80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70576 10.366C6.18405 10.6422 6.79564 10.4783 7.07178 10C7.34793 9.5217 7.18405 8.91011 6.70576 8.63397L4.10768 7.13397C3.62939 6.85783 3.0178 7.02171 2.74166 7.5C2.46552 7.97829 2.62939 8.58988 3.10768 8.86602L5.70576 10.366Z",
    fill: "#023F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74165 20.5C2.46551 20.0217 2.62939 19.4101 3.10768 19.134L5.70576 17.634C6.18405 17.3578 6.79564 17.5217 7.07178 18C7.34792 18.4783 7.18405 19.0899 6.70576 19.366L4.10768 20.866C3.62939 21.1422 3.0178 20.9783 2.74165 20.5Z",
    fill: "#023F80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9282 10C20.652 9.52171 20.8159 8.91012 21.2942 8.63398L23.8923 7.13398C24.3706 6.85783 24.9822 7.02171 25.2583 7.5C25.5345 7.97829 25.3706 8.58989 24.8923 8.86603L22.2942 10.366C21.8159 10.6422 21.2043 10.4783 20.9282 10Z",
    fill: "#023F80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8.03125C10.7035 8.03125 8.03122 10.7036 8.03122 14C8.03122 17.2964 10.7035 19.9688 14 19.9688C17.2964 19.9688 19.9687 17.2964 19.9687 14C19.9687 10.7036 17.2964 8.03125 14 8.03125ZM9.99216 14C9.99216 11.6454 11.6454 9.99219 14 9.99219C16.3546 9.99219 18.0156 11.6454 18.0156 14C18.0156 16.3546 16.3546 18 14 18C11.6454 18 9.99216 16.3546 9.99216 14Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunOutline);
export default __webpack_public_path__ + "static/media/sun_outline.2ba5912847e980f0202df6e64ef60d83.svg";
export { ForwardRef as ReactComponent };